import sanitize from 'sanitize-html'

// Intentionally omits position/top/left/right/bottom/z-index to prevent overlay attacks on consumer portals.
export const allowedStyles: sanitize.IOptions['allowedStyles'] = {
  '*': {
    display: [/^[\w-]+$/],
    'flex-flow': [/^[\w ]+$/],
    'flex-direction': [/^[\w-]+$/],
    flex: [/^[\d.\s%a-z]+$/],
    'flex-shrink': [/^\d+$/],
    'flex-grow': [/^\d+$/],
    'flex-wrap': [/^[\w-]+$/],
    'align-items': [/^[\w-]+$/],
    'align-content': [/^[\w-]+$/],
    'align-self': [/^[\w-]+$/],
    'justify-content': [/^[\w-]+$/],
    'justify-items': [/^[\w-]+$/],
    'justify-self': [/^[\w-]+$/],
    order: [/^\d+$/],
    gap: [/^[\d.\s%a-z]+$/],
    'column-gap': [/^[\d.%a-z]+$/],
    'row-gap': [/^[\d.%a-z]+$/],
    'grid-template-columns': [/^.+$/],
    'grid-template-rows': [/^.+$/],
    'grid-column': [/^[\w\s/.-]+$/],
    'grid-row': [/^[\w\s/.-]+$/],
    'min-width': [/^[\d.%a-z]+$/],
    'max-width': [/^[\d.%a-z]+$/],
    'min-height': [/^[\d.%a-z]+$/],
    'max-height': [/^[\d.%a-z]+$/],
    width: [/^[\d.%a-z]+$/],
    height: [/^[\d.%a-z]+$/],
    'box-sizing': [/^[\w-]+$/],
    margin: [/^[\d.\s%a-z-]+$/],
    'margin-top': [/^[\d.%a-z-]+$/],
    'margin-bottom': [/^[\d.%a-z-]+$/],
    'margin-left': [/^[\d.%a-z-]+$/],
    'margin-right': [/^[\d.%a-z-]+$/],
    float: [/^(left|right|none)$/],
    padding: [/^[\d.\s%a-z]+$/],
    'padding-top': [/^[\d.%a-z]+$/],
    'padding-bottom': [/^[\d.%a-z]+$/],
    'padding-left': [/^[\d.%a-z]+$/],
    'padding-right': [/^[\d.%a-z]+$/],
    color: [/^.+$/],
    background: [/^.+$/],
    'background-color': [/^.+$/],
    'font-family': [/^.+$/],
    'font-weight': [/^[\w]+$/],
    'font-size': [/^[\d.%a-z]+$/],
    'font-style': [/^[\w-]+$/],
    'line-height': [/^[\d.%a-z]+$/],
    'letter-spacing': [/^[\d.%a-z-]+$/],
    'text-transform': [/^[\w-]+$/],
    'overflow-x': [/^[\w-]+$/],
    'overflow-wrap': [/^[\w-]+$/],
    'word-break': [/^[\w-]+$/],
    'white-space': [/^[\w-]+$/],
    'text-decoration': [/^[\w ]+$/],
    'text-underline-offset': [/^[\d.%a-z]+$/],
    'text-align': [/^(left|right|center|justify)$/],
    'vertical-align': [/^(top|middle|bottom|baseline)$/],
    'list-style': [/^[\w-]+$/],
    'list-style-type': [/^[\w-]+$/],
    border: [/^.+$/],
    'border-top': [/^.+$/],
    'border-bottom': [/^.+$/],
    'border-left': [/^.+$/],
    'border-right': [/^.+$/],
    'border-color': [/^.+$/],
    'border-style': [/^[\w ]+$/],
    'border-width': [/^[\w .]+$/],
    'border-radius': [/^[\d.\s%a-z]+$/],
    opacity: [/^[\d.]+$/],
  },
}

// Shared by the footer and landing page, which both persist CKEditor output and render it on the consumer portal.
// Values are kept loose on purpose (the sanitised CKEditor output).
export const richContentSanitizeOptions: sanitize.IOptions = {
  allowedTags: [...sanitize.defaults.allowedTags, 'img'],
  allowedAttributes: {
    ...sanitize.defaults.allowedAttributes,
    '*': ['style'],
    a: ['id', 'href', 'rel', 'target', 'title'],
    img: ['src', 'alt', 'width', 'height'],
  },
  allowedStyles,
  allowedClasses: {
    ['*']: false, // lets all classes through
  }
}

export const sanitizeRichContentHtml = (html: string): string => sanitize(html, richContentSanitizeOptions)
